import { Component, input } from '@angular/core';
import { UserModel } from '../../../../core/models/data/user.model';
import { SplitNavigationPanelComponent } from '../../../../parts/split-navigation-panel/split-navigation-panel.component';
import { SplitNavContentDirective } from '../../../../core/directives/split-nav-content.directive';
import { SplitNavigationPanelConstants } from '../../../../core/constants/split-navigation-panel.constants';
import { UserPaymentMethodsComponent } from '../user-payment-methods/user-payment-methods.component';

@Component({
  selector: 'ms-user-settings',
  imports: [SplitNavigationPanelComponent, SplitNavContentDirective, UserPaymentMethodsComponent],
  templateUrl: './user-settings.component.html'
})
export class UserSettingsComponent {
  public user = input<UserModel | undefined>(undefined);

  public settingsPanelTitle = 'User Settings';
  public settingsNavItems = SplitNavigationPanelConstants.USER_SETTINGS_NAV_ITEMS();

  public onSettingsTabChanged(tabId: string): void {
    this.settingsNavItems.forEach(item => {
      item.active = item.id === tabId;
    });
  }
}
